import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down-chevron",
  "use": "down-chevron-usage",
  "viewBox": "50 50 395 395",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"50 50 395 395\" id=\"down-chevron\"><path fill=\"currentColor\" d=\"M115.881 203.106 247.5 334.297l131.619-131.191-28.238-28.33L247.5 277.82 144.119 174.776z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol